<template>
  <div
    :class="{
      character_item_wrapper: true,
      selected: isSelectedCharacter && inListItem
    }"
  >
    <div>
      <div class="character_item_name">{{ character.gcName }}</div>
      <div class="character_server_info">
        <span class="character_item_name">{{ character.worldName }}</span>
        <span>
          <span class="bar"></span>
          <span class="character_item_name">Lv.{{ character.gcLevel }}</span>
        </span>
        <span>
          <span class="bar"></span>
          <span class="character_item_name">{{ character.gcClass }}</span>
        </span>
      </div>
    </div>
    <button
      :class="{ select_button: true, on: isSelectedCharacter }"
      @click="handleSelectedCharacter"
    >
      {{
        isSelectedCharacter
          ? $t('character.setting_in_progress_D08')
          : $t('character.select_D12')
      }}
      <img
        class="check_icon"
        v-if="isSelectedCharacter"
        src="../../assets/images/ico_check_purple.png"
      />
    </button>
  </div>
</template>

<script>
import { isLogin } from '@/utils'
import ProductsListSimple from '@/views/shop/ProductsListSimple'
import { mapGetters } from 'vuex'

export default {
  name: 'MyShopping',
  components: {
    ProductsListSimple
  },
  props: {
    character: {
      type: Object,
      required: true
    },
    isSelectedCharacter: {
      type: Boolean,
      default: false
    },
    inListItem: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLogin: isLogin()
    }
  },
  computed: {
    ...mapGetters('main', ['enableReward', 'enableCart']),
    ...mapGetters('cart', ['cartUniqueQuantity']),
    ...mapGetters('my', ['loginID', 'nexonName', 'couponCount', 'balance']),
    ...mapGetters('recent', ['recentList'])
  },
  methods: {
    handleSelectedCharacter() {
      this.$emit('selectCharacter', this.character)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.character_item_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;
  background-color: #fff;
  border-bottom: 1px #ededed solid;
  .character_server_info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 10px;
    font-size: 13px;
    line-height: 18px;
    font-family: 'Noto Sans KR';
    color: #636376;
  }
  .character_item_name {
    margin-right: 4px;
  }
}

.character_item_wrapper.selected {
  background-color: #efeafe;
}
.bar {
  display: inline-block;
  width: 1px;
  height: 12px;
  margin: 0 6px 0 1px;
  background-color: #a5a5ac;
}
.select_button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Noto Sans KR';
  width: 78px;
  height: 36px;
  border-radius: 5px;
  border: solid 1px #bcbcc0;
  background-color: #fff;
  color: #636376;
  font-size: 13px;
}
.on {
  border: solid 1px #6134f1;
  color: #6134f1;
}
.check_icon {
  margin-left: 2px;
}
</style>
